import { tap } from 'lodash'
import { ApiCaller, callApi, getUrlWithPathParams } from 'services/api'

import { Organization } from '../organizations/types'
import { DigitalPresence } from './types'

const DIGITAL_PRESENCES_ENDPOINT_PATH = '/digital-presences/'

const apiPostDigitalPresence = (apiCaller: ApiCaller) => async (
  { label, value }: DigitalPresence,
  organizationId: Organization['id']
): Promise<DigitalPresence> => {
  const formData = tap(new FormData(), (fd) => {
    fd.set('label', label || '')
    fd.set('organizationId', `${organizationId}`)

    const isValueAFile = typeof value !== 'string'
    if (isValueAFile) {
      fd.set('file', value)
    } else {
      fd.set('url', value)
    }
  })

  return await apiCaller<DigitalPresence>({
    data: formData,
    method: 'post',
    url: getUrlWithPathParams(DIGITAL_PRESENCES_ENDPOINT_PATH),
  })
}

export const apiPostDigitalPresenceAsAdmin = apiPostDigitalPresence(callApi)

const apiDeleteDigitalPresence = (apiCaller: ApiCaller) => async (digitalPresence: DigitalPresence): Promise<void> => {
  return await apiCaller<void>({
    method: 'delete',
    url: getUrlWithPathParams(DIGITAL_PRESENCES_ENDPOINT_PATH, digitalPresence.id),
  })
}

export const apiDeleteDigitalPresenceAsAdmin = apiDeleteDigitalPresence(callApi)
